import PageRenderer from "../components/PageRenderer";

const Unterstuetzen = () => <PageRenderer pageName="Unterstuetzen" analyticsPath="/unterstuetzen" />;

export default Unterstuetzen;
